import React from 'react';
import './Services.css';

import { FaArrowRight } from 'react-icons/fa';

import imgWeb from './assets/web.jpeg';
import imgMobile from './assets/mobile.jpeg';
import imgDesktop from './assets/desktop.jpeg';

const Services = () => {
  return (
    <div className="container__services">
      <h1 className="services__title">Servicios</h1>
      <div className="services__cards">
        <div className="container__card">
          <div className="card__img">
            <img src={imgWeb} alt="" className="img" />
          </div>
          <div className="card__title">Web</div>
          <div className="card__description">
            Creamos sitios web personalizados que combinan diseño atractivo y
            funcionalidad avanzada. Nuestro equipo utiliza las últimas
            tecnologías para asegurar que tu página sea responsiva, optimizada y
            fácil de usar.
          </div>
        </div>
        <div className="container__card">
          <div className="card__img">
            <img src={imgMobile} alt="" className="img" />
          </div>
          <div className="card__title">Mobile</div>
          <div className="card__description">
            Desarrollamos aplicaciones móviles innovadoras, enfocándonos en
            usabilidad, rendimiento y seguridad. Transformamos tus ideas en
            aplicaciones destacadas en el mercado móvil.
          </div>
        </div>
        <div className="container__card">
          <div className="card__img">
            <img src={imgDesktop} alt="" className="img" />
          </div>
          <div className="card__title">Software</div>
          <div className="card__description">
            Ofrecemos aplicaciones de escritorio potentes y personalizadas para
            mejorar la productividad de tu negocio. Nuestras soluciones son
            fáciles de usar y se integran perfectamente con tus sistemas
            existentes.
          </div>
        </div>
      </div>
      <div className="container__offers">
        <h1 className="offers__title">Ofertas a la medida para tu proyecto</h1>
        <p className="offers__description">
          En un mundo digital en constante evolución, cada proyecto es único y
          necesita soluciones personalizadas. Por eso, he creado 'Ofertas a la
          medida' que se adaptan a tus necesidades específicas, sin importar la
          complejidad de tu proyecto. Ya sea que necesites flexibilidad en la
          duración, servicios especializados o tarifas personalizadas, estoy
          aquí para ayudarte a alcanzar tus metas. Descubre cómo podemos
          colaborar y llevar tu visión al siguiente nivel.
        </p>
        <div className="offers__cards">
          <div className="offer__container green">
            <h5 className="offer__subtopic">Desarrollo - Web Page</h5>
            <h3 className="offer__topic">Plan Kairos</h3>
            <p className="offer__description">
              Flexibilidad total, paga solo por las horas que tu proyecto
              necesita.
            </p>
            <div className="offer__line"></div>
            <div className="offer__bottom">
              <div className="offer__priceContainer">
                <h3 className="offer_Price">Contratar</h3>
              </div>
              <a
                href="https://wa.me/message/VRAREXKMRRRME1"
                className="button__arrow"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowRight className="fa-arrow-right" />
              </a>
            </div>
          </div>
          <div className="offer__container gray">
            <h5 className="offer__subtopic">Desarrollo - Web App</h5>
            <h3 className="offer__topic">Plan Prometeo</h3>
            <p className="offer__description">
              Obtén servicios de desarrollo Web de alta calidad por una tarifa
              mensual fija.
            </p>
            <div className="offer__line"></div>
            <div className="offer__bottom">
              <div className="offer__priceContainer">
                <h3 className="offer_Price">Contratar</h3>
              </div>
              <a
                href="https://wa.me/message/VRAREXKMRRRME1"
                className="button__arrow"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowRight className="fa-arrow-right" />
              </a>
            </div>
          </div>
          <div className="offer__container purple">
            <h5 className="offer__subtopic">Desarrollo - Mobile</h5>
            <h3 className="offer__topic">Plan Hefesteo</h3>
            <p className="offer__description">
              Obtén servicios de desarrollo de aplicaciones móviles de alta
              calidad por una tarifa mensual fija.
            </p>
            <div className="offer__line"></div>
            <div className="offer__bottom">
              <div className="offer__priceContainer">
                <h3 className="offer_Price">Contratar</h3>
              </div>
              <a
                href="https://wa.me/message/VRAREXKMRRRME1"
                className="button__arrow"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowRight className="fa-arrow-right" />
              </a>
            </div>
          </div>
          <div className="offer__container orange">
            <h5 className="offer__subtopic">Desarrollo - Software</h5>
            <h3 className="offer__topic">Plan Pegasus</h3>
            <p className="offer__description">
              Adquirí nuestros servicios para el desarrollo de un software de
              alta calidad por una tarifa mensual fija.
            </p>
            <div className="offer__line"></div>
            <div className="offer__bottom">
              <div className="offer__priceContainer">
                <h3 className="offer_Price">Contratar</h3>
              </div>
              <a
                href="https://wa.me/message/VRAREXKMRRRME1"
                className="button__arrow"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowRight className="fa-arrow-right" />
              </a>
            </div>
          </div>
          <div className="offer__container yellow">
            <h5 className="offer__subtopic">Web + Mobile</h5>
            <h3 className="offer__topic">Plan Fenix</h3>
            <p className="offer__description">
              La combinación perfecta para proyectos integrales: Diseño y
              desarrollo.
            </p>
            <div className="offer__line"></div>
            <div className="offer__bottom">
              <div className="offer__priceContainer">
                <h3 className="offer_Price">Contratar</h3>
              </div>
              <a
                href="https://wa.me/message/VRAREXKMRRRME1"
                className="button__arrow"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowRight className="fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container__extra">
        <div className="column__left">
          <h1 className="extra__title">
            ¿Ningún plan se ajusta a tus necesidades?
          </h1>
          <p className="extra__description">
            Si ninguno de los planes propuestos se ajusta a tus necesidades, no
            dudes en contactarnos. Estamos dispuestos a negociar una solución
            personalizada que se adapte a tus objetivos. Tu satisfacción es
            nuestra prioridad.
          </p>
          <a
            href="https://wa.me/message/VRAREXKMRRRME1"
            className="text__a-modificated btn__services"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conoce Más
          </a>
        </div>
        <div className="column__right">
          <div className="offer__container rose">
            <h5 className="offer__subtopic">Web, Mobile y/o Software</h5>
            <h3 className="offer__topic">Plan Unicornio</h3>
            <p className="offer__description">
              ¿Eres el tipo de cliente que nunca se adapta a los planes
              "normales"? ¿Negociamos?
            </p>
            <div className="offer__line"></div>
            <div className="offer__bottom">
              <div className="offer__priceContainer">
                <h3 className="offer_Price">A convenir</h3>
              </div>
              <a
                href="https://wa.me/message/VRAREXKMRRRME1"
                className="button__arrow"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowRight className="fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
